import script from "./RoleSectionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionForm.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionForm.vue?vue&type=style&index=0&id=36402634&lang=css"

const __exports__ = script;

export default __exports__